import React, { CSSProperties } from "react"
import { Paper, CircularProgress } from "material-ui"
import strings from "../../localization/strings"
import autobind from "class-autobind"
import AccountStore from "../../stores/AccountStore"
import PayrollJobCostingPieChart from "./PayrollJobCostingPieChart"
import { IPayrollTime } from "../../models"
import { checkPositionFieldAvailable } from "../../helpers/positionHelper"
import { checkJobFieldAvailable } from "../../helpers/jobHelper"
interface IProps {
    loading: boolean
    payrollData: IPayrollTime
}
interface IState {
    expanded: boolean
}

export default class PayrollJobCostingSummaryCard extends React.Component<IProps, IState>  {
    private enableEquipment
    constructor(props: IProps) {
        super(props)
        this.enableEquipment = AccountStore.getEquipmentEnabled()
        this.state = {
            expanded: false
        }
        autobind(this)
    }

    handleExpandCard() {
        this.setState({ expanded: !this.state.expanded })
    }

    getPercentAndMaximum(data, defaultName) {
        const allHours = data.reduce((total, item) => total + item.TotalHours, 0)
        let tempPercentData = []
        data.forEach((item) => {
            const name = item.Name ? item.Name : defaultName
            const percent = allHours === 0 ? Math.floor(10000 / data.length) / 100 : Math.floor((item.TotalHours / allHours) * 10000) / 100
            tempPercentData.push({ name, percent })
        })

        tempPercentData.sort((a, b) => {
            return a.name === defaultName && a.percent === b.percent ? 0 : b.percent - a.percent
        })

        const lastItemName = tempPercentData[tempPercentData.length - 1].name
        tempPercentData = tempPercentData.filter((item, index) => {
            return index === 0 || item.percent > 10
        })
        if (tempPercentData.length !== data.length) {
            tempPercentData.push({
                name: data.length - tempPercentData.length === 1 ? lastItemName : strings.Other,
                percent: 0
            })
        }

        //recalculating last item percent to sum is 100
        let percentSum = 0
        tempPercentData.forEach((item, index) => {
            if (index !== tempPercentData.length - 1) {
                percentSum = Math.round((percentSum + item.percent) * 100) / 100
            }
        })
        tempPercentData[tempPercentData.length - 1].percent = Math.round((100 - percentSum) * 100) / 100

        if (tempPercentData[tempPercentData.length - 1].name !== strings.Other) {
            tempPercentData.sort((a, b) => {
                return b.percent - a.percent
            })
        }

        const percentData = []
        tempPercentData.forEach((item) => {
            const ellipsisName = item.name.length > 12 ? item.name.substr(0, 12) + "..." : item.name
            percentData.unshift({
                ellipsisName,
                value: item.percent,
                name: item.name
            })
        })

        const maxItem = percentData[percentData.length - 1]
        return { maxItem, percentData }
    }

    render() {
        const { payrollData, loading } = this.props
        const { expanded } = this.state
        const { enableEquipment } = this

        let hierarchyDistributionData, positionDistributionData, equipmentDistributionData
        if (payrollData && payrollData.JobCostingSummary) {
            const hierarchyDistribution = payrollData.JobCostingSummary.HierarchyDistribution
            if (hierarchyDistribution.length > 0) {
                hierarchyDistributionData = this.getPercentAndMaximum(hierarchyDistribution, strings.No_Hierarchy)
            }
            const positionDistribution = payrollData.JobCostingSummary.PositionDistribution
            if (positionDistribution.length > 0) {
                positionDistributionData = this.getPercentAndMaximum(positionDistribution, strings.No_Position)
            }
            const equipmentDistribution = payrollData.JobCostingSummary.EquipmentDistribution
            if (equipmentDistribution.length > 0) {
                equipmentDistributionData = this.getPercentAndMaximum(equipmentDistribution, strings.No_Equipment)
            }
        }

        const isValidJobCostingSummaryData =
            payrollData && payrollData.JobCostingSummary &&
                (hierarchyDistributionData && hierarchyDistributionData.maxItem) &&
                (positionDistributionData && positionDistributionData.maxItem) &&
                (equipmentDistributionData && equipmentDistributionData.maxItem) ?
                true :
                false
                
        return (
            <Paper
                data-intercom-target={"menu-Payroll-JobCostingSummaryExapansionPanel"}
                zDepth={1}
                className="page-paper"
                style={{ marginTop: -5, marginBottom: 25, paddingTop: 0, height: expanded ? 325 : 80 }}
            >
                <div style={{ position: "absolute", right: 15, top: 28, fontSize: 20 }}>
                    <i data-intercom-target={"menu-Payroll-JobCostingSummary-Btn-Expande"} className={"fa " + (expanded ? "fa-chevron-up" : "fa-chevron-down") + " itemActionButton"} onClick={this.handleExpandCard} />
                </div>
                {expanded ?
                    <div style={{ padding: "5px 35px" }}>
                        <div style={styles.expandedTitle as CSSProperties}>{ checkJobFieldAvailable('singular') ? `${AccountStore.getCurrentAccountSettings().CustomFieldSettings.JobFieldLabels.SingularJobLabel} Costing Summary`: strings.Job_Costing_Summary}</div>
                        {loading ?
                            <div style={{ textAlign: "center", marginTop: 100 }}>
                                <CircularProgress />
                            </div> :
                            <div>
                                {isValidJobCostingSummaryData ?
                                    <div>
                                        <div style={Object.assign(styles.expandedChart, { width: enableEquipment ? "33%" : "50%" })}>
                                            <div style={styles.expandedChartTitle as CSSProperties}>{strings.Hierarchy_Distribution}</div>
                                            <div style={{ paddingTop: 25 }}>
                                                <PayrollJobCostingPieChart data={hierarchyDistributionData.percentData} />
                                            </div>
                                        </div>
                                        <div style={Object.assign(styles.expandedChart, { width: enableEquipment ? "33%" : "50%" })}>
                                            <div style={styles.expandedChartTitle as CSSProperties}>{strings.Position_Distribution}</div>
                                            <div style={{ paddingTop: 25 }}>
                                                <PayrollJobCostingPieChart data={positionDistributionData.percentData} />
                                            </div>
                                        </div>
                                        {enableEquipment &&
                                            <div style={Object.assign(styles.expandedChart, { width: "33%" })}>
                                                <div style={styles.expandedChartTitle as CSSProperties}>{strings.Equipment_Distribution}</div>
                                                <div style={{ paddingTop: 25 }}>
                                                    <PayrollJobCostingPieChart data={equipmentDistributionData.percentData} />
                                                </div>
                                            </div>
                                        }
                                    </div> :
                                    <div style={{ textAlign: "center", fontSize: 20, marginTop: 100 }}>
                                        { checkJobFieldAvailable('singular') ? `No ${AccountStore.getCurrentAccountSettings().CustomFieldSettings.JobFieldLabels.SingularJobLabel} Costing Summary Data`: strings.No_Job_Costing_Summary_Data}
                                    </div>
                                }
                            </div>
                        }
                    </div> :
                    <div style={{ display: "flex" }}>
                        <div style={{ fontSize: 15, fontWeight: "bold", width: 200, textAlign: "center", paddingTop: 31 }}>
                            {checkJobFieldAvailable('singular') ? `${AccountStore.getCurrentAccountSettings().CustomFieldSettings.JobFieldLabels.SingularJobLabel} Costing Summary` :strings.Job_Costing_Summary}
                        </div>
                        <div style={{ flex: 1, backgroundColor: "rgb(231, 231, 231)", width: "80%", height: 80 }}>
                            {loading ?
                                <div style={{ textAlign: "center", marginTop: 20 }}>
                                    <CircularProgress />
                                </div> :
                                <div style={{ marginTop: -6 }}>
                                    {isValidJobCostingSummaryData ?
                                        <div>
                                            <div style={Object.assign(styles.collapsedTopDistributionGroup, { width: enableEquipment ? "33%" : "50%" })}>
                                                <div style={styles.collapsedTopDistributionTitle as CSSProperties}>{strings.Hierarchy_Distribution}</div>
                                                <div style={styles.collapsedTopDistribution}>
                                                    {`${strings.Top}: `}
                                                    {hierarchyDistributionData.maxItem.ellipsisName + " - "}
                                                    {hierarchyDistributionData.maxItem.value + "%"}
                                                </div>
                                            </div>
                                            <div style={Object.assign(styles.collapsedTopDistributionGroup, { width: enableEquipment ? "33%" : "50%" })}>
                                                <div style={styles.collapsedTopDistributionTitle as CSSProperties}>{checkPositionFieldAvailable('singular') ?`${AccountStore.getCurrentAccountSettings().CustomFieldSettings.PositionFieldLabels.SingularPositionLabel} Distribution`  :strings.Position_Distribution}</div>
                                                <div style={styles.collapsedTopDistribution}>
                                                    {`${strings.Top}: `}
                                                    {positionDistributionData.maxItem.ellipsisName + " - "}
                                                    {positionDistributionData.maxItem.value + "%"}
                                                </div>
                                            </div>
                                            {enableEquipment &&
                                                <div style={Object.assign(styles.collapsedTopDistributionGroup, { width: "33%" })}>
                                                    <div style={styles.collapsedTopDistributionTitle as CSSProperties}>{strings.Equipment_Distribution}</div>
                                                    <div style={styles.collapsedTopDistribution}>
                                                        {`${strings.Top}: `}
                                                        {equipmentDistributionData.maxItem.ellipsisName + " - "}
                                                        {equipmentDistributionData.maxItem.value + "%"}
                                                    </div>
                                                </div>
                                            }
                                        </div> :
                                        <div style={{ textAlign: "center", fontSize: 20, marginTop: 35 }}>
                                            { checkJobFieldAvailable('singular') ? `No ${AccountStore.getCurrentAccountSettings().CustomFieldSettings.JobFieldLabels.SingularJobLabel} Costing Summary Data`: strings.No_Job_Costing_Summary_Data}
                                        </div>
                                    }
                                </div>
                            }
                        </div>
                        <div style={{ width: 50 }} />
                    </div>
                }
            </Paper>
        )
    }
}

const styles = {
    collapsedTopDistributionGroup: {
        display: "inline-block",
        textAlign: "center"
    },
    collapsedTopDistributionTitle: {
        fontSize: 16,
        fontWeight: 500,
        marginTop: 30
    },
    collapsedTopDistribution: {
        fontSize: 13,
        color: "rgba(0, 0, 0, 0.5)"
    },
    expandedTitle: {
        fontSize: 15,
        fontWeight: 500,
        paddingTop: 15
    },
    expandedChart: {
        textAlign: "center",
        display: "inline-block"
    },
    expandedChartTitle: {
        marginTop: 25,
        fontSize: 14,
        fontWeight: 500
    }
}
